var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37126 0.0710449C1.14114 0.0710449 0.95459 0.257595 0.95459 0.487712C0.95459 0.717828 1.14114 0.904378 1.37126 0.904378H2.04353C2.43158 0.904378 2.76827 1.17222 2.85552 1.55033L4.68473 9.47688C4.99012 10.8003 6.16854 11.7377 7.52671 11.7377H14.3713C15.7354 11.7377 16.9173 10.7921 17.2168 9.4613L18.4241 4.09544C18.5999 3.31393 18.0057 2.57104 17.2046 2.57104H3.94631L3.66751 1.36295C3.49301 0.606728 2.81962 0.0710449 2.04353 0.0710449H1.37126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62126 12.571C6.70078 12.571 5.95459 13.3172 5.95459 14.2377C5.95459 15.1582 6.70078 15.9044 7.62126 15.9044C8.54176 15.9044 9.28792 15.1582 9.28792 14.2377C9.28792 13.3172 8.54176 12.571 7.62126 12.571Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2878 12.571C13.3673 12.571 12.6211 13.3172 12.6211 14.2377C12.6211 15.1582 13.3673 15.9044 14.2878 15.9044C15.2083 15.9044 15.9544 15.1582 15.9544 14.2377C15.9544 13.3172 15.2083 12.571 14.2878 12.571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartIcon);
export default __webpack_public_path__ + "static/media/shopping-cart-icon.91a9bc3ef73614ec295b7b516fcc061b.svg";
export { ForwardRef as ReactComponent };